import ThemeToggle from "@/components/theme-toggle.jsx";
import LastUpdatedCounter from "@/components/last-updated-counter.jsx";

/**
 * Shared header actions cluster: theme toggle and optional last-updated counter.
 * @param {Object} props
 * @param {boolean} [props.showLastUpdated=false] - Whether to show LastUpdatedCounter
 * @param {"assets" | "downtime"} [props.lastUpdatedContext] - Counter context when shown
 * @returns {JSX.Element}
 */
export default function PageHeaderActions({
  showLastUpdated = false,
  lastUpdatedContext,
}) {
  return (
    <div className='flex items-center gap-3'>
      <ThemeToggle />
      {showLastUpdated && (
        <LastUpdatedCounter context={lastUpdatedContext} />
      )}
    </div>
  );
}
